module.exports = __webpack_public_path__ + "media/images/new_user-03998f7db89f211895b2bbddb6680d1c.png";